import { render } from "./Schedule.vue?vue&type=template&id=b2807946&scoped=true"
import script from "./Schedule.vue?vue&type=script&lang=js"
export * from "./Schedule.vue?vue&type=script&lang=js"

import "./Schedule.vue?vue&type=style&index=0&id=b2807946&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2807946"]])

export default __exports__